import React from 'react'
import { Link } from 'react-router-dom'

function Hero() {
  return (
  <section className='hero-marble-bg relative min-h-[640px] md:min-h-[720px] bg-no-repeat bg-cover bg-center'>
  <div className="absolute inset-0 bg-black/45"></div>
    <div className="absolute -top-24 -right-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"></div>
    <div className="absolute bottom-10 left-6 h-40 w-40 rounded-full bg-white/5 blur-2xl"></div>

  <div className='container mx-auto flex justify-center items-center h-full relative z-10 pt-28 md:pt-32 pb-16'>
        <div className='text-center max-w-4xl mx-auto px-6'>

          <div className="flex flex-col items-center gap-5 mb-6">
            <img
              src="/images/marcial-blanco-transparente.png"
              alt="Distribuidora Marcial"
              className="h-34 w-auto sm:h-48"
            />
            <span className='px-4 py-2 text-xs uppercase tracking-[3px] text-amber-200 bg-white/10 border border-white/20 rounded-full shadow-sm'>
              Libros, Grabaciones y Tecnologia Magnetica
            </span>
          </div>

          {/* <h1 className='font-vintage-display text-3xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-5 leading-tight'>
            Abastecimiento inteligente
            <span className="block text-slate-700">para tu negocio</span>
          </h1> */}

          <p className='text-lg md:text-xl text-slate-200 mb-8 max-w-2xl mx-auto leading-relaxed font-light'>
            Disciplina, conocimiento y herramientas para el equilibrio físico y mental
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
            <Link 
              to={'/#productos'} 
              className='hero-btn-light px-6 py-2.5 text-sm sm:text-base transform hover:scale-105'
            >
              Ver catálogo
            </Link>

            <Link 
              to={'/'} 
              className='hero-btn-light px-6 py-2.5 text-sm sm:text-base transform hover:scale-105'
            >
              Solicitar cotización
            </Link>
          </div>

          {/* Elementos decorativos inferiores */}
          {/* <div className="mt-12 flex justify-center items-center space-x-8 opacity-60">
            <div className="hidden md:block w-12 h-[1px] bg-stone-500"></div>
            <span className="font-vintage-display text-xs text-stone-500 tracking-[3px] uppercase">
              Desde 1985
            </span>
            <div className="hidden md:block w-12 h-[1px] bg-stone-500"></div>
          </div> */}
        </div>
      </div>
    </section>
  )
}

export default Hero
